import React, { useContext } from 'react'
import styled from 'styled-components'
import { Outlet } from 'react-router-dom'
import ThemeContext from '../contexts/theme.context'


const StyledBackground = styled.div`
  min-height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  position: relative;
  // padding: 0.625rem;
  height: 100%;
`

const BasicLayout = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <StyledBackground className={`app ${theme}`}>
      <Outlet />
    </StyledBackground>

  )
}

export default BasicLayout